import React, { useState } from 'react';
import { UtilityFunctions } from "../utils/UtilityFunctions";
import { STRING_CONSTANTS } from "../utils/constants/stringConstants";
import { userService } from '../_services';
import ToastHeader from "../components/toastHeader";
import ValidationErrorToast from '../components/validationErrorToast';
import SuccessToast from '../components/successToast';
import { authCardStyles as styles } from './authCardStyles';

const ForgotPassword = (props) => {
  const [email, setEmail] = useState(props && props.location && props.location.state && props.location.state.email || "");
  const [btnClick, setBtnClick] = useState(false);
  const store = !UtilityFunctions.validateEmail(email);

  const handleSubmit = (e) => {
    e.preventDefault();
    setBtnClick(true);
    if (UtilityFunctions.isEmptyOrNullOrUndefined(email)) {
      ValidationErrorToast(STRING_CONSTANTS.formLabelString.label_toast_email, STRING_CONSTANTS.validationString.req_email);
    }
    else if (store) {
      ValidationErrorToast(STRING_CONSTANTS.formLabelString.label_toast_email, STRING_CONSTANTS.validationString.req_email_incorrect);
    }
    else {
      if (!(email)) {
        return;
      }
      let data = {
        email: email
      }
      userService.forgotPassword(data)
        .then((res) => {
          SuccessToast(STRING_CONSTANTS.SUCCESS_MESSAGES.SUCCESS_HEADER, STRING_CONSTANTS.SUCCESS_MESSAGES.EMAIL_SENT_MESSAGE);
          setTimeout(() => {
            props.history.push(STRING_CONSTANTS.navigationString.login);
          }, 1000);
        })
        .catch(function (error) {
          ToastHeader(error);
        });
    }
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.header}>
          <i className="fa fa-angle-left" style={styles.backArrow} aria-hidden="true" onClick={() => props.history.goBack()}></i>
          <span style={styles.logoChip} onClick={() => props.history.push(STRING_CONSTANTS.navigationString.login)}>
            <img alt="MPLOI" style={styles.logo} src={UtilityFunctions.getImageURL() + "logo_White.svg"} />
          </span>
        </div>
        <h1 style={styles.title}>Forgot password</h1>
        <p style={styles.subtitle}>Enter your email and we’ll send you a link to reset your password.</p>

        <form onSubmit={handleSubmit} noValidate>
          <div style={styles.formGroup}>
            <label htmlFor="floatingInput" style={styles.label}>Email Address</label>
            <input
              type="email"
              id="floatingInput"
              placeholder="Enter Email"
              name='email'
              style={{
                ...styles.input,
                ...(btnClick && store && email.length > 0 ? styles.inputError : {})
              }}
              value={email}
              onChange={(e) => { setEmail(e.target.value); setBtnClick(false); }}
            />
          </div>

          <button
            type='submit'
            style={{ ...styles.button, ...(store ? styles.buttonDisabled : {}) }}
          >
            Send reset link
          </button>
        </form>

        <p style={styles.footerText}>
          Remembered it?{' '}
          <button type='button' style={styles.footerLink} onClick={() => props.history.push(STRING_CONSTANTS.navigationString.login)}>
            Sign in
          </button>
        </p>
      </div>
    </div>
  )
}
export default ForgotPassword;
